import { render, staticRenderFns } from "./modal-ver_escogidos.vue?vue&type=template&id=6f296ce6&scoped=true"
import script from "./modal-ver_escogidos.vue?vue&type=script&lang=js"
export * from "./modal-ver_escogidos.vue?vue&type=script&lang=js"
import style0 from "./modal-ver_escogidos.vue?vue&type=style&index=0&id=6f296ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f296ce6",
  null
  
)

export default component.exports